module.exports = __webpack_public_path__ + "static/media/homeSkeletonSm.93b26547.svg";